import { MoreHoriz } from "@mui/icons-material";
import { Box, ClickAwayListener, IconButton, MenuList, Paper, Popper } from "@mui/material";
import React, { PropsWithChildren, useRef, useState } from "react";

const TableRowMenu: React.FC<PropsWithChildren> = (props) => {
  const { children } = props;
  const anchorRef = useRef<HTMLButtonElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <ClickAwayListener onClickAway={() => setIsOpen(false)}>
      <Box component="span">
        <IconButton
          ref={anchorRef}
          size="small"
          edge="end"
          sx={{ my: -0.5 }}
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(!isOpen);
          }}
        >
          <MoreHoriz />
        </IconButton>

        <Popper
          open={isOpen}
          anchorEl={anchorRef.current}
          placement="bottom"
          modifiers={[
            {
              name: "preventOverflow",
              enabled: true,
              options: {
                mainAxis: true,
                altAxis: true,
                altBoundary: false,
                tether: false,
                rootBoundary: "viewport",
                padding: 20,
              },
            },
            {
              name: "hide",
              enabled: true,
              options: {
                isReferenceHidden: true,
                hasPopperEscaped: true,
                placement: "top",
              },
            },
          ]}
          sx={{
            "&[data-popper-reference-hidden]": {
              visibility: "hidden",
              pointerEvents: "none",
            },
          }}
        >
          <Paper elevation={3} sx={{ position: "relative" }}>
            <MenuList
              onClick={(e) => {
                e.stopPropagation();
                setIsOpen(false);
              }}
            >
              {children}
            </MenuList>
          </Paper>
        </Popper>
      </Box>
    </ClickAwayListener>
  );
};

export default TableRowMenu;
